import { maunaMissionAPI } from '@/api';
import CommonSpaceListContainer from '@/components/common/CommonSpaceListContainer';
import MaunaHeader from './MaunaHeader';
import { createColumnHelper, ColumnDef } from '@tanstack/react-table';

interface MissionDataType {
  id: number;
  group: string | number | null;
  publish: boolean;
  title: string;
  count: number;
  category: number;
  type: number;
  auto: boolean;
  autoComplete: boolean;
  needReset: boolean;
  description: string;
  createdAt: string;
}

const columnHelper = createColumnHelper<MissionDataType>();

const categoryMap: Record<number, string> = {
  1: '서비스 내 행동유도',
  2: '장소 방문형',
  3: '보물찾기',
  4: '걸음 인식',
};

const typeMap: Record<number, string> = {
  1: '일반미션',
  2: '관리자승인미션',
};

const getColumns = (): ColumnDef<MissionDataType, unknown>[] => {
  const baseColumns = [
    columnHelper.accessor('id', {
      header: 'ID',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('group', {
      header: '그룹',
      cell: (info) => info.getValue() ?? '-',
    }),
    columnHelper.accessor('publish', {
      header: '앱 노출',
      cell: (info) => (info.getValue() ? 'ON' : 'OFF'),
    }),
    columnHelper.accessor('title', {
      header: '미션명',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('count', {
      header: '횟수',
      cell: (info) => info.getValue(),
    }),
    columnHelper.accessor('category', {
      header: '카테고리',
      cell: (info) => categoryMap[info.getValue()] || info.getValue(),
    }),
    columnHelper.accessor('type', {
      header: '타입',
      cell: (info) => typeMap[info.getValue()] || info.getValue(),
    }),
    columnHelper.accessor('auto', {
      header: '자동 시작',
      cell: (info) => (info.getValue() ? 'ON' : 'OFF'),
    }),
    columnHelper.accessor('autoComplete', {
      header: '자동 완료',
      cell: (info) => (info.getValue() ? 'ON' : 'OFF'),
    }),
    columnHelper.accessor('needReset', {
      header: '월 리셋',
      cell: (info) => (info.getValue() ? 'ON' : 'OFF'),
    }),
    columnHelper.accessor('description', {
      header: '설명',
      cell: (info) => {
        const text = info.getValue() || '';
        const truncated = text.length > 20 ? `${text.slice(0, 20)}...` : text;
        return <span title={text}>{truncated}</span>;
      },
    }),
    columnHelper.accessor('createdAt', {
      header: '생성 날짜',
      cell: (info) => new Date(info.getValue()).toLocaleDateString(),
    }),
  ];

  return baseColumns.filter(Boolean) as ColumnDef<MissionDataType, unknown>[];
};

const MaunaMissionContainer = () => {
  return (
    <CommonSpaceListContainer<MissionDataType>
      HeaderComponent={MaunaHeader}
      queryKey="getMissionsMauna"
      queryFn={() =>
        maunaMissionAPI.getMissions({
          code: import.meta.env.VITE_SECRET_API_KEY,
        })
      }
      columns={getColumns}
      baseRoute="/mauna/mission"
      buttonColor="resom"
      showCreateButton={false}
    />
  );
};

export default MaunaMissionContainer;
